import { render, staticRenderFns } from "./BuyingGuide.vue?vue&type=template&id=71c704d4&"
import script from "./BuyingGuide.vue?vue&type=script&lang=js&"
export * from "./BuyingGuide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports